export default {
  eyebrow: 'Partnerportal',
  title: 'Servicegebyrberegner',
  description: 'Beregn et estimat af servicegebyrindtægterne fra restauranterne under din partnerkonto.',
  toasts: {
    load_error: 'Dine indstillinger for servicegebyr kunne ikke indlæses.',
  },
};
